import type { ReactNode } from 'react';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { HeaderActionProvider } from '@/contexts/HeaderActionContext';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <HeaderActionProvider>
      <div className="flex min-h-screen flex-col bg-background">
        <Header />
        <main className="flex-1 overflow-y-auto pb-[calc(5rem+env(safe-area-inset-bottom))]">{children}</main>
        <BottomNav />
      </div>
    </HeaderActionProvider>
  );
}
